import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card } from 'react-bootstrap';
import { has, isEmpty } from 'lodash';

import Header from './Header';
import RecentlyAdded from './Dashboard/RecentlyAdded';
import Footer from './Footer';
import Loader from '../../core-components/Loader';
import localStorage from '../../api/localStorage';
import { getErrorMessage } from '../../utils/utilities';

import styles from './CompanyAdmin.module.scss';

export default (props) => {
  const [recentCandidates, setRecentCandidates] = useState([]);
  const [loading, setLoading] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    props?.getCandidates('10', '0').then(() => {
      setRecentCandidates(props?.candidates?.all[0]?.candidates);
      setLoading(props?.candidates?.loading);
    });

    if (!props?.profile || isEmpty(props?.profile) || !has(props?.profile, 'profile')) {
      props
        ?.logout()
        .then(() => {
          localStorage.clearStorage();
          window.location.reload();
        })
        .catch((error) => {
          toast.error(getErrorMessage(error));
        });
    }
  }, []);

  return (
    <div>
      {props?.profile && !isEmpty(props?.profile) && has(props?.profile, 'profile') ? (
        <>
          <RecentlyAdded data={recentCandidates} loading={loading} {...props} />
        </>
      ) : (
        <Card className={styles.loadingviewCandidateCard}>
          <Loader className={styles.viewCandidateLoader} />
        </Card>
      )}
    </div>
  );
};
